
//------------------------------------------------------------------------------

const conditionalTests = {
    'equals'    : (answers, expected) => { return answers.includes(expected); },
    'notequals' : (answers, expected) => { return !answers.includes(expected); },
};

const conditionalActions = {
    'visibility'    : (action, question, inverted) => { question.toggleAttribute('hidden', !inverted); },
};

//------------------------------------------------------------------------------

//
const surveys = document.querySelectorAll('form.survey');
for (const survey of surveys) {

    //
    const surveyRules = JSON.parse(survey.dataset.surveyLogic);

    if (typeof surveyRules == 'object' && surveyRules !== null) {

        //
        survey.addEventListener('change', (event) => {
            updateSurveyState(survey, surveyRules);
        });
        updateSurveyState(survey, surveyRules);

    }

}

//------------------------------------------------------------------------------

/**
 * [updateSurveyState description]
 * @param  {[type]} form  [description]
 * @param  {[type]} rules [description]
 * @return {[type]}       [description]
 */
function updateSurveyState(survey, rules) {
    for (const rule of rules) {
        doActions(survey, doTests(survey, rule.tests[0], rule.tests[1]), rule.actions);
    }
}

/**
 * [doTests description]
 * @param  {[type]} mode  [description]
 * @param  {[type]} tests [description]
 * @return {[type]}       [description]
 */
function doTests(survey, mode, tests) {

    //
    const results = [];

    //
    for (const test of tests) {
        const question = survey.querySelector('.survey-question[data-question-id="' + test[0] + '"]');
        if (question) {
            const answers = getQuestionAnswers(question);
            if (test[1] in conditionalTests) {
                results.push(conditionalTests[test[1]](answers, test[2]));
            }
        }
    }

    //
    if (mode == 'all') {
        return results.every((v) => v === true);
    } else {
        return results.some((v) => v === true);
    }

    //
    return false;

}

/**
 * [doActions description]
 * @param  {[type]} inverted [description]
 * @param  {[type]} actions  [description]
 * @return {[type]}          [description]
 */
function doActions(survey, inverted, actions) {
    for (const action of actions) {
        console.log(action, inverted)
        const question = survey.querySelector('.survey-question[data-question-id="' + action[0] + '"]');
        if (question) {
            if (action[1] in conditionalActions) {
                conditionalActions[action[1]](action[2], question, inverted);
            }
        }
    }
}

/**
 * Get the answers for a question as an array of values
 * @param  element question
 * @return array
 */
function getQuestionAnswers(question) {

    //get all the inputs by the name attribute (throw an error if it's not found)
    const inputs = question.querySelectorAll('input, select, textarea');

    //create an array to store the results (we may be dealing with a multiple choice input)
    let inputValues = [];

    //
    for (const input of inputs) {

        //
        const inputType = (input.getAttribute('type') || input.tagName);

        //select - both single and multi selects
        if (inputType === 'select') {
            for (const selectedOption of input.querySelectorAll('option:selected')) {
                inputValues.push(selectedOption.value);
            }
            continue;
        }

        //process the input if it's a "radio button" or "checkbox"
        if (inputType === 'radio' || inputType === 'checkbox') {
            if (input.checked === true) {
                inputValues.push(input.value);
            }
            continue;
        }

        //everything else - make sure to trim it while we are at it
        inputValues.push(((String(input.value).trim() == '') ? undefined : String(input.value).trim()));

    }

    //filter out any undefined or null values
    inputValues = inputValues.filter(function(value) { return !(typeof value === 'undefined' || value === null); });

    //
    return inputValues;

}

//------------------------------------------------------------------------------

//toggle the "question information" block if it's included on a question
const toggleQuestionInformationIcons = document.querySelectorAll('i[data-action="toggle-question-information"]');
for (const toggleQuestionInformationIcon of toggleQuestionInformationIcons) {

    //
    toggleQuestionInformationIcon.addEventListener('click', (event) => {

        //
        event.preventDefault();

        //
        const additionalContentPanel = toggleQuestionInformationIcon.closest('.survey-question').querySelector('.question-information');
        additionalContentPanel.dispatchEvent(new Event('toggle'));

    });

}

//------------------------------------------------------------------------------
